import Card from "./Card";
import DataStateHandler from "./DataStateHandler";

/**
 * Standard layout for data pages: Card + DataStateHandler with consistent bodyClassName.
 * When loading, error, or empty: body keeps padding for messages. When showing data (e.g. table): bodyClassName is "p-0".
 * Use this instead of manually composing Card + DataStateHandler + bodyClassName logic.
 */
export default function DataPageCard({
  title,
  right,
  className = "",
  bodyClassName,
  isLoading,
  error,
  isEmpty,
  loadingMessage = "Loading...",
  emptyMessage = "No data available",
  showLoadingSpinner = false,
  children,
}) {
  const hasData = !isLoading && !error && !isEmpty;
  const resolvedBodyClassName = bodyClassName !== undefined ? bodyClassName : hasData ? "p-0" : "";

  return (
    <Card title={title} right={right} className={className} bodyClassName={resolvedBodyClassName}>
      <DataStateHandler
        isLoading={isLoading}
        error={error}
        isEmpty={isEmpty}
        loadingMessage={loadingMessage}
        emptyMessage={emptyMessage}
        showLoadingSpinner={showLoadingSpinner}
      >
        {children}
      </DataStateHandler>
    </Card>
  );
}
